var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 175,
    viewBox: "0 0 191 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.867 51.7834C133.72 51.7834 135.223 50.2794 135.223 48.4242C135.223 46.5689 133.72 45.0649 131.867 45.0649C130.013 45.0649 128.51 46.5689 128.51 48.4242C128.51 50.2794 130.013 51.7834 131.867 51.7834Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.713 69.9498C43.9324 69.9498 44.921 68.9603 44.921 67.7397C44.921 66.5191 43.9324 65.5297 42.713 65.5297C41.4935 65.5297 40.5049 66.5191 40.5049 67.7397C40.5049 68.9603 41.4935 69.9498 42.713 69.9498Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8633 109.682C54.0828 109.682 55.0714 108.693 55.0714 107.472C55.0714 106.252 54.0828 105.262 52.8633 105.262C51.6439 105.262 50.6553 106.252 50.6553 107.472C50.6553 108.693 51.6439 109.682 52.8633 109.682Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.298 21.9497C108.639 33.7303 109.933 36.3479 110.357 47.9561C110.194 50.6058 110.093 53.4871 108.843 55.8073C107.175 59.3565 103.094 61.8145 99.239 61.8543C95.2673 61.9253 91.3735 59.4935 89.6209 55.7436C88.3878 53.4678 88.427 50.3549 90.1184 48.2887C91.9572 46.307 95.192 45.8129 97.519 47.0511C100.079 48.227 101.607 50.672 102.172 53.2506C102.738 55.8291 102.49 58.6258 101.799 61.1687C100.354 67.3532 99.1578 67.6524 95.6148 78.1231",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.58 15.7142C109.57 17.4465 107.958 18.5072 105.913 17.9541C103.761 17.5872 102.237 17.209 102.139 15.6629C102.189 14.0774 103.919 13.4568 105.943 12.7573C108.371 11.7926 109.442 14.0215 109.58 15.7142Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6714 21.0115C96.7622 22.1344 99.0621 22.4618 100.183 20.7466C101.412 18.8451 102.464 17.4628 101.333 16.1931C100.243 15.0702 99.181 15.8262 96.7532 16.7909C94.807 17.7839 94.3939 19.7813 95.6714 21.0115Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.704 13.8459C101.697 13.4228 102.886 13.7332 103.417 14.5345C103.643 14.7885 103.908 15.1891 103.986 15.4825C104.831 17.4575 104.566 19.4154 103.426 19.878C102.177 20.5268 100.457 19.4151 99.7992 17.5474C99.642 16.9606 99.5634 16.6671 99.4455 16.227C99.3179 15.1606 99.7112 14.2691 100.704 13.8459C100.851 13.8065 100.704 13.8459 100.704 13.8459Z",
    fill: "#F1F3F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.704 13.8459C101.697 13.4228 102.886 13.7332 103.417 14.5345C103.643 14.7885 103.908 15.1891 103.986 15.4825C104.831 17.4575 104.566 19.4154 103.426 19.878C102.177 20.5268 100.457 19.4151 99.7992 17.5474C99.642 16.9606 99.5634 16.6671 99.4455 16.227C99.3179 15.1606 99.7112 14.2691 100.704 13.8459ZM100.704 13.8459C100.704 13.8459 100.851 13.8065 100.704 13.8459Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0721 45.6379H53.1503V43.716H51.5029V45.6379H49.5811V47.3401H51.5029V49.262H53.1503V47.3401H55.0721V45.6379Z",
    fill: "#AAB2C5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2928 93.8569H57.371V91.935H55.7236V93.8569H53.8018V95.5591H55.7236V97.481H57.371V95.5591H59.2928V93.8569Z",
    fill: "#AAB2C5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.308 93.9655L140.957 92.7783L142.144 90.4269L140.128 89.4093L138.941 91.7607L136.59 90.5735L135.538 92.6562L137.89 93.8434L136.702 96.1949L138.718 97.2125L139.905 94.861L142.257 96.0482L143.308 93.9655Z",
    fill: "#AAB2C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2782_10781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6675 109.682L95.6529 99.9732V60.166L64.6675 69.8004V109.682Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 109.682L95.6523 99.9733V60.166L126.638 69.8004V109.682Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6529 119.466L64.6675 109.757V69.9498L95.6529 79.6588V119.466Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6523 119.466L126.638 109.757V69.9498L95.6523 79.6589V119.466Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6525 60.166L81.0842 49.262L49.5811 59.8673L64.6671 69.8004L95.6525 60.166Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6523 60.166L110.221 49.262L141.724 59.8673L126.638 69.8004L95.6523 60.166Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6671 69.9498L95.6525 79.6588L80.1968 89.5173L49.5811 79.3601L64.6671 69.9498Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.638 69.9498L95.6523 79.6589L111.108 89.5173L141.724 79.3601L126.638 69.9498Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.225 121.301H90.0111C88.6655 121.301 87.5786 120.212 87.5786 118.864V101.904C87.5786 97.1842 91.4084 93.3981 96.0663 93.3981C100.724 93.3981 104.554 97.2361 104.554 101.904V118.915C104.606 120.212 103.519 121.301 102.225 121.301ZM92.4435 116.478H99.7927V101.904C99.7927 99.8812 98.1365 98.2215 96.1181 98.2215C94.0997 98.2215 92.4435 99.8812 92.4435 101.904V116.478Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 1.26464,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.246 125.917H85.1468C83.6459 125.917 82.4038 124.672 82.4038 123.168V108.491C82.4038 106.987 83.6459 105.742 85.1468 105.742H107.246C108.747 105.742 109.989 106.987 109.989 108.491V123.168C109.989 124.672 108.747 125.917 107.246 125.917Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 1.26464,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8819 116.332C98.6301 115.797 99.1345 114.915 99.1345 113.904C99.1345 112.257 97.8161 110.934 96.1698 110.934C94.5235 110.934 93.2051 112.257 93.2051 113.904C93.2051 114.915 93.7095 115.797 94.4577 116.332V118.492C94.4577 119.446 95.2146 120.206 96.1698 120.206C97.125 120.206 97.8819 119.446 97.8819 118.492V116.332Z",
    fill: "white",
    stroke: "#AAB2C5",
    strokeWidth: 1.26464
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2782_10781",
    x: 0.581055,
    y: 0.261955,
    width: 190.143,
    height: 174.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0 0.619608 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2782_10781"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.403922 0 0 0 0 0.431373 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2782_10781",
    result: "effect2_dropShadow_2782_10781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2782_10781",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledDataIcon);
export default __webpack_public_path__ + "static/media/DisabledDataIcon.f7f27e1fb1ce029f18e48a10f7a8eabf.svg";
export { ForwardRef as ReactComponent };